export function getScrollPosition(state, scrollContainerId, scale) {
    var scrollPosition = state.scrollContainer.scrollPosition[scrollContainerId];
    if (!scrollPosition)
        return [];
    return scrollPosition.map(scale);
}
